<template>
	<SimpleModalComponent
		:heading="heading"
		@close-modal="emit( 'close-modal' )"
	>
		<template #content>
			<p
				v-if="type_is_staff"
				class="mb-16"
			>
				You are about to approve this upload and make it visible to the client.
			</p>
			<p
				v-else-if="type_is_client && approval_is_final"
				class="mb-16"
			>
				You are about to approve this stage as the final asset. The asset and all its comment threads will be locked and you will be able to download the high-res version(s) of it.
			</p>
			<template v-else-if="type_is_client">
				<p class="mb-32">
					You are about to approve the following asset:
				</p>

				<img
					v-if="option.thumbnail_url || option.image_small_url"
					class="approval-thumbnail-image"
					:src="option.thumbnail_url || option.image_small_url"
					:alt="option.title"
				>
				<p class="mb-32">
					{{ option.title }}
				</p>

				<p>
					The Boundary will be notified and move to Stage B.
				</p>
			</template>
		</template>

		<template #buttons>
			<button
				class="button"
				@click="emit( 'close-modal' )"
			>
				Cancel
			</button>
			<button
				class="button button--fill"
				@click="emitApproval"
			>
				Approve
			</button>
		</template>
	</SimpleModalComponent>
</template>

<script setup>
import SimpleModalComponent from './SimpleModalComponent.vue';

import { computed, defineProps, defineEmits } from 'vue';
import {
	USER_GROUP_CLIENT,
	USER_GROUP_STAFF
} from '../../constants';

const props = defineProps( {
	type: {
		required: true,
		type: String
	},
	revision: {
		required: true,
		type: Object
	},
	option: {
		required: true,
		type: Object
	}
} );

const emit = defineEmits( ['close-modal', 'approve', 'approve-final-revision'] );

const type_is_client = computed( () => {
	return props.type === USER_GROUP_CLIENT;
} );
const type_is_staff = computed( () => {
	return props.type === USER_GROUP_STAFF;
} );

const stage = computed( () => {
	return props.revision.revision_number[0];
} );
const approval_is_final = computed( () => {
	return stage.value === 'B';
} );

const heading = computed( () => {
	if ( type_is_staff.value ) {
		return 'Are you sure you want to approve this upload?';
	}
	return `Are you sure you want to approve Stage ${stage.value}?`;
} );

const emitApproval = () => { // eslint-disable-line snakecasejs/snakecasejs
	if ( type_is_client.value && approval_is_final.value ) {
		emit( 'approve-final-revision' );
		return;
	}
	emit( 'approve' );
};
</script>
